<template>
  <div
    ref="table"
    class="c-table"
    :class="{
      'c-table_scrolled': isScrolled,
      'c-table_scroll_end': isScrollEnd,
      'c-table_scroll': isScroll,
    }"
  >
    <m-column-filters
      ref="columnFilters"
      :column="filteredColumn"
      :reference-list="referenceList"
      :active-filters="activeFilteredColumns"
      @getReferenceValues="getReferenceValues"
      @close="filteredColumn = null"
      @setFilter="setColumnFilter"
      @removeFilter="removeColumnFilter"
    />

    <div
      v-if="data.records.length !== 0"
      :class="{
        'c-table__shadow': data.actions,
        'c-table__shadow_active': data.actions,
        // 'c-table__empty__shadow': data.records.length === 0
      }"
    ></div>
    <div v-if="isScroll" class="c-table__scrollbar-wrapper"></div>

    <div class="c-table__wrapper">
      <table ref="container" class="c-table__container">
        <thead ref="header" class="c-table__header">
          <tr v-for="i in levels" :key="i" class="c-table__header-row">
            <th
              v-for="column in getTableColumns(i)"
              :id="`c-table-column-${column.id}`"
              :key="column.id"
              class="c-table__column"
              :style="{ width: column.width ? column.width : '' }"
              :colspan="getColspan(column)"
              :rowspan="getRowspan(column)"
              :class="{
                'c-table__column_with_filter': column.type,
                'c-table__column_hidden': isDisabled(column.id),
                'c-table__column_sorted': isSorted(column),
              }"
            >
              <div class="c-table__column-wrapper">
                <div
                  class="c-table__column-label"
                  :class="{ 'c-table__column-label-children': !isCategory(column) && sortedColumn }"
                  @click="setSortedColumn(column, sortedColumn)"
                >
                  {{ column.label }}
                </div>

                <!--              <div class="c-table__column-actions"-->
                <!--                   v-if="column.description || column.type"-->
                <!--              >-->
                <!--                <div class="c-table__column-action c-table__column-action_description" v-if="column.fullName">-->
                <!--                  <c-button-->
                <!--                    size="small"-->
                <!--                    icon="info"-->
                <!--                    :id="`table-column-button-description-${column.id}`"-->
                <!--                    noBorder-->
                <!--                  />-->

                <!--                  <b-popover placement="top" triggers="hover" :target="`table-column-button-description-${column.id}`">-->
                <!--                    {{ column.fullName }}-->
                <!--                  </b-popover>-->
                <!--                </div>-->

                <!--                <div class="c-table__column-action" v-if="isColumnFiltered(column.id)">-->
                <!--                  <c-button-->
                <!--                    size="small"-->
                <!--                    noBorder-->
                <!--                    :id="`table-column-button-filter-${column.id}`"-->
                <!--                    :active="isColumnActiveFiltered(column.id)"-->
                <!--                    @click="openColumnFilterModal(column)"-->
                <!--                    :icon="{-->
                <!--                        icon: 'filter-column',-->
                <!--                        activeColor: 'blue'-->
                <!--                      }"-->
                <!--                  />-->

                <!--                  <b-popover placement="top" triggers="hover"-->
                <!--                             :target="`table-column-button-filter-${column.id}`">-->
                <!--                    {{ isColumnActiveFiltered(column.id) ? 'Изменить фильтр' : 'Применить фильтр' }}-->
                <!--                  </b-popover>-->
                <!--                </div>-->
                <!--              </div>-->
              </div>
            </th>

            <th v-if="data.actions && i === 1" class="c-table__column c-table__column_actions" :rowspan="levels">
              <div class="c-table__column-empty"></div>
            </th>
          </tr>
        </thead>

        <tbody class="c-table__records">
          <template v-for="(record, recordIndex) in data.records">
            <template v-if="record.isShowRow">
              <tr :key="`transaction-${recordIndex}`" class="c-table__record">
                <td
                  v-for="column in getTableColumns(levels)"
                  :key="column.id"
                  class="c-table__cell"
                  :class="{
                    'c-table__cell_string': column.type === 'string',
                    'c-table__cell_reference': column.type === 'reference',
                    'c-table__cell_number': column.type === 'number',
                    'c-table__cell_date': column.type === 'date',
                    'c-table__cell_hidden': isDisabled(column.id),
                    'c-table__cell__green': column.id === 'sum_bonus' && record[column.id].value > 0,
                    'c-table__cell__red': column.id === 'sum_penalty' && record[column.id].value > 0,
                    ['c-table__cell_' + column.id]: column.id,
                  }"
                >
                  <div
                    v-if="column.id !== 'date' && column.id !== 'amount'"
                    :class="{
                      'c-table__cell-pre-formatted': column.id === 'postCategorySpecialty',
                    }"
                    class="c-table__cell-value"
                  >
                    {{ numberWithSpaces(record[column.id].value) }}
                  </div>
                  <div
                    v-else-if="column.id === 'amount'"
                    :class="{
                      'c-table__cell__text__green': record[column.id].value > 0,
                      'c-table__cell__text__red': record[column.id].value < 0,
                    }"
                    class="c-table__cell-value"
                  >
                    {{ formatAmount(record[column.id].value) }}
                  </div>
                  <div v-else-if="column.id === 'date'" class="c-table__cell-value c-table__cell-value-dropdown">
                    <svg
                      v-if="record.childrens.length > 0"
                      v-b-toggle="recordIndex.toString()"
                      class="c-table__cell-value-dropdown-button"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="11" cy="11" r="10.5" fill="white" stroke="#D3D8DF" />
                      <path
                        d="M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z"
                        fill="#0066FF"
                      />
                      <path
                        d="M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z"
                        fill="#0066FF"
                      />
                    </svg>
                    <div class="c-table__cell-value-dropdown-value">{{ record[column.id].value }}</div>
                  </div>
                </td>

                <td v-if="data.actions" class="c-table__cell c-table__cell_actions">
                  <div class="c-table__cell-actions">
                    <c-table-actions :record="record" />
                  </div>
                </td>
              </tr>

              <template v-for="rec in record.childrens">
                <tr
                  v-if="record.childrens.length > 0"
                  :key="`record-${rec.workerName}`"
                  class="c-table__record c-table__record__grey"
                  style="border-bottom-style: hidden; border-top-style: hidden"
                >
                  <td
                    v-for="column in getTableColumns(levels)"
                    :key="column.id"
                    class="c-table__cell"
                    :class="{
                      'c-table__cell_string': column.type === 'string',
                      'c-table__cell_reference': column.type === 'reference',
                      'c-table__cell_number': column.type === 'number',
                      'c-table__cell_date': column.type === 'date',
                      'c-table__cell_hidden': isDisabled(column.id),
                      'c-table__cell__green': column.id === 'sum_bonus' && rec[column.id].value > 0,
                      'c-table__cell__red': column.id === 'sum_penalty' && rec[column.id].value > 0,
                      ['c-table__cell_' + column.id]: column.id,
                    }"
                  >
                    <b-collapse :id="recordIndex.toString()">
                      <div v-if="column.id === 'date'" class="c-table__cell-value c-table__cell__grey">
                        {{ rec.workerName }}
                      </div>
                      <div
                        v-else-if="column.id === 'amount'"
                        :class="{
                          'c-table__cell__text__green': rec[column.id].value > 0,
                          'c-table__cell__text__red': rec[column.id].value < 0,
                        }"
                        class="c-table__cell-value"
                      >
                        {{ formatAmount(rec[column.id].value) }}
                      </div>
                      <div v-else class="c-table__cell-value">
                        {{ rec[column.id].value }}
                      </div>
                    </b-collapse>
                  </td>

                  <td v-if="data.actions" style="width: 40px" class="c-table__cell c-table__cell_actions">
                    <b-collapse :id="recordIndex.toString()">
                      <div class="c-table__cell__grey c-table__cell-actions">
                        <c-table-actions :record="rec" />
                      </div>
                    </b-collapse>
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </tbody>
      </table>
    </div>

    <div v-if="data.records.length === 0" class="c-table__empty__records">{{ emptyRecordsLabel }}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import DataTableActions from "@/pages/calculations/create/additions/sidesheet-additions/data-table-personal-transactions-actions";
import ColumnFiltersModal from "@/components/modals/column-filters";

export default {
  name: "c-table",

  components: {
    "c-table-actions": DataTableActions,
    "m-column-filters": ColumnFiltersModal,
  },

  props: [
    "levels",
    "maxWidth",
    "data",
    "enabledFields",
    "disabledColumns",
    "sortedColumn",
    "filteredColumns",
    "activeFilteredColumns",
    "referenceList",
    "emptyRecordsLabel",
  ],

  data() {
    return {
      isScrolled: false,
      isScrollEnd: false,
      isScroll: false,
      positionTop: 0,
      filterFieldsBlockHeight: 0,
      filteredColumn: null,
    };
  },

  computed: {
    ...mapGetters("app", ["sidebarCollapsed"]),

    // sortedRecords: function() {
    //   if (!this.sortedColumn) {
    //     return this.data.records
    //   }
    //
    //   let sortedColumn = this.sortedColumn.sortBy
    //   let sortType = (this.sortedColumn.sortType === 'asc') ? 1 : -1
    //   let sortedColumns
    //
    //   if (sortedColumn === 'created') {
    //     sortedColumns = this.data.records.sort(function(a, b) {
    //       let dateA = moment(a[sortedColumn].value, "DD-MM-YYYY").format('X')
    //       let dateB = moment(b[sortedColumn].value, "DD-MM-YYYY").format('X')
    //       if (isNaN(dateA) || isNaN(dateB)) {
    //         return 0
    //       }
    //       if (sortType === -1) {
    //         return (dateB > dateA) ? 1 : (dateA > dateB) ? -1 : 0;
    //       } else if (sortType === 1) {
    //         return (dateA > dateB) ? 1 : (dateB > dateA) ? -1 : 0;
    //       } else {
    //         return 0;
    //       }
    //     })
    //   } else {
    //     sortedColumns = this.data.records.sort(function (a, b) {
    //       if (a[sortedColumn].value.toLowerCase() < b[sortedColumn].value.toLowerCase()) {
    //         return -1 * sortType;
    //       } else if (a[sortedColumn].value > b[sortedColumn].value) {
    //         return 1 * sortType;
    //       } else {
    //         return 0;
    //       }
    //     })
    //   }
    //
    //   return sortedColumns
    // }
  },

  watch: {
    "enabledFields": function () {
      this.updatePositionTop();
    },

    "isScrollEnd": function () {
      // console.log('value: ', value)
    },

    "data.columns": function () {
      // console.log('value: ', value)
    },

    "disabledColumns": function (value) {
      const enabledColumns = this.data.columns.filter((item) => !value.includes(item.id));

      const max = Math.max.apply(
        null,
        enabledColumns.map((item) => item.level),
      );

      this.$emit("setLevelsTableData", max + 1);
      // this.levels = max + 1;

      this.setTableShadow();
    },
  },

  mounted() {
    this.updatePositionTop();

    window.addEventListener("touchend", this.handleTouchMove, {
      passive: false,
    });
    document.querySelector(".layout").addEventListener("scroll", this.handleLayoutScroll);
    document.querySelector(".ps").addEventListener("scroll", this.handleTableScroll);

    if (this.$refs.wrapper) this.isScroll = this.$refs.wrapper.$el.clientWidth < this.$refs.wrapper.$el.scrollWidth;
    setTimeout(() => {
      // this.setTableShadow()
    }, 1500);
  },

  methods: {
    numberWithSpaces(x) {
      if (x === null) {
        return null;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    formatAmount(x) {
      if (x > 0) {
        return `+${x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      if (x < 0) {
        return `−${(-1 * x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    handleTableScroll() {
      this.setTableShadow();
    },

    handleTouchMove() {
      // if (!e.cancelable) {
      //   e.preventDefault();
      //   return true
      // }
    },

    setTableShadow() {
      if (this.data.actions === undefined) {
        return;
      }
      const ps = document.querySelector(".ps");
      // const tableWrapper = document.querySelector(".c-table__wrapper");
      const tableWrapperShadow = document.querySelector(".c-table__shadow");

      if (!ps || !tableWrapperShadow) return;

      const fullScrollWidth = ps.scrollWidth - ps.clientWidth;

      const diff = Math.abs(ps.scrollLeft - fullScrollWidth);

      if (diff > 3 && this.data.records.length !== 0) {
        tableWrapperShadow.classList.add("c-table__shadow_active");
      } else {
        tableWrapperShadow.classList.remove("c-table__shadow_active");
      }
    },

    resetColumnFilters() {
      this.activeFilteredColumns = [];

      this.$refs.columnFilters.resetFilters();
    },

    isColumnFiltered(columnId) {
      if (this.filteredColumns === undefined) {
        return false;
      }
      const result = this.filteredColumns.findIndex((i) => i === columnId);

      return result !== -1;
    },

    isColumnActiveFiltered(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      return c !== -1;
    },

    setColumnFilter(e) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === e.id);

      const filterOptions = {
        id: e.id,
        type: e.type,
        searchType: e.filter.condition.value,
        value: e.type === "number" && e.filter.condition.value === "4" ? e.filter.rangeValue : e.filter.value,
      };

      if (
        c === -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        return;
      }

      if (
        c !== -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (
        c === -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        return;
      }

      if (
        c !== -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1 && filterOptions.type === "list" && filterOptions.value.length === 0) {
        return;
      }

      if (c !== -1 && filterOptions.value.length === 0) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1) {
        this.activeFilteredColumns.push(filterOptions);
      } else {
        this.activeFilteredColumns.splice(c, 1);
        this.activeFilteredColumns[c] = filterOptions;
      }
    },

    isCategory(column) {
      return column.isCategory === 1;
    },

    isSorted(column) {
      return column.isSorted;
    },

    setSortedColumn(column, sortedColumn) {
      if (column.isCategory !== 1 && sortedColumn !== undefined) {
        const c = this.data.columns.findIndex((i) => i.id === sortedColumn.sortBy);

        if (c !== -1) {
          this.data.columns[c].isSorted = false;
        }

        column.isSorted = true;
        this.sortedColumn.sortBy = column.id;

        if (column.id === sortedColumn.sortBy) {
          this.sortedColumn.sortType = this.sortedColumn.sortType === "asc" ? "desc" : "asc";
        } else {
          this.sortedColumn.sortType = "asc";
        }

        this.$emit("sortedEvent", this.sortedColumn);
      }
    },

    removeColumnFilter(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      if (c !== -1) {
        this.activeFilteredColumns.splice(c, 1);
      }
    },

    openColumnFilterModal(column) {
      const c = this.filteredColumns.findIndex((i) => i === column.id);

      if (c !== -1) {
        this.filteredColumn = column;
      }
    },

    handleLayoutScroll() {
      const layout = document.querySelector(".layout");
      const app = document.querySelector(".app");

      let result = layout.scrollTop - this.positionTop;

      if (app.offsetWidth < 992) {
        result += 50;
      }

      if (layout.scrollTop > this.positionTop) {
        if (this.$refs.header) {
          this.$refs.header.classList.add("c-table__header-shadow");
          this.$refs.header.style.transform = `translateY(${result}px)`;
        }
      } else if (this.$refs.header) {
        this.$refs.header.classList.remove("c-table__header-shadow");
        this.$refs.header.style.transform = "none";
      }
    },

    updatePositionTop() {
      const header = this.$refs.header.getBoundingClientRect();
      const layout = document.querySelector(".layout");
      this.positionTop = header.top + layout.scrollTop;
    },

    isDefaultCell(record, column) {
      return !record[column.id].employee && !record[column.id].depositState;
    },

    getChildrens(columnId) {
      return this.data.columns.filter((item) => item.parentColumnId === columnId);
    },

    getTableColumns(level) {
      let out = [];

      const columns = this.data.columns.filter((item) => item.parentColumnId === undefined);

      if (level === 1) {
        out = out.concat(columns);
      } else if (level === 2) {
        Object.keys(columns).forEach((i) => {
          out = out.concat(this.getChildrens(columns[i].id));
        });
      } else if (level === 3) {
        Object.keys(columns).forEach((i) => {
          const childrens = this.getChildrens(columns[i].id);

          Object.keys(childrens).forEach((ii) => {
            out = out.concat(this.getChildrens(childrens[ii].id));
          });
        });
      }

      return out;
    },

    getColumns(level) {
      let cols = [];

      if (level === 1) {
        cols = this.data.columns.filter((col) => col.parentColumnId === undefined);
      } else if (level === 2) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          cols = cols.concat(childrens);
        });
      } else if (level === 3) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          Object.keys(childrens).forEach((ii) => {
            const childrens2 = this.data.columns.filter((col) => col.parentColumnId === childrens[ii].id);
            cols = cols.concat(childrens2);
          });
        });
      }

      return cols;
    },

    getColspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      let count = children.length;

      if (column.level === 0) {
        Object.keys(children).forEach((c) => {
          const childrenChildren = this.data.columns
            .filter((col) => col.parentColumnId === children[c].id)
            .filter((colChild) => !this.disabledColumns.includes(colChild.id));

          count += childrenChildren.length;
        });
      }

      Object.keys(children).forEach((i) => {
        const result = this.disabledColumns.find((item) => item === children[i].id || children[i].isCategory === 1);

        if (result) {
          count -= 1;
        }
      });

      return count;
    },

    getRowspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      if (this.levels === 3) {
        if (column.level === 0 && children.length === 0) {
          return 3;
        }
        if (column.level === 1 && children.length === 0) {
          return 2;
        }
      } else if (this.levels === 2) {
        if (column.level === 0 && children.length === 0) {
          return 2;
        }
      }

      return 1;
    },

    getSeletItemLabel(record, column) {
      let cell = null;

      if (column.items) {
        const item = column.items.find((i) => i.value === record[column.name]);

        cell = item ? item.label : "-";
      } else {
        cell = "-";
      }

      return cell;
    },

    scroll() {
      // const layout = document.querySelector(".layout");
      // layout.classList.add('layout-touch-action-none');
      this.isScrolled = this.$refs.wrapper.$el.scrollLeft > 0;
      const containerWidth = this.$refs.container.offsetWidth;
      const wrapperWidth = this.$refs.wrapper.$el.offsetWidth;
      const { scrollLeft } = this.$refs.wrapper.$el;
      this.isScrollEnd = containerWidth - scrollLeft === wrapperWidth - 1;
      // layout.classList.remove('layout-touch-action-none');
    },

    isDisabled(id) {
      return this.disabledColumns.find((item) => item === id);
    },

    getReferenceValues(e) {
      this.$emit("getReferenceValues", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-table {
  position: relative;
  display: inline-block;
  max-width: 100%;

  &__collapse {
    &-table {
      width: calc(100% + 1px);
      margin-left: -1px;
      border-collapse: collapse;
    }
  }

  &__record {
    &__grey {
      background: #f5f7fa !important;

      & td {
        background: #f5f7fa !important;
      }
    }
  }

  &__scrollbar-wrapper {
    position: fixed;
    height: 24px;
    background: white;
    box-shadow: $box-shadow;
    bottom: 0;
    left: 0;
    z-index: 100;
    transition: 0.2s;

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    max-width: 100%;
  }

  @media screen and (max-width: 700px) {
    margin: 0 -20px;
    width: calc(100% + 40px);
    max-width: none;
  }

  &__wrapper {
    //overflow-x: auto;
    position: relative;
    transition: 0.2s;
    display: inline-block;
    width: 100%;

    &::-webkit-scrollbar {
      height: 0;
    }

    @media screen and (max-width: 992px) {
      width: 100%;
    }
  }

  &__shadow {
    position: absolute;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
    width: 10px;
    height: calc(100% - 10px);
    right: 92px;
    opacity: 0;
    bottom: 10px;
    visibility: hidden;
    z-index: 80;
    transition: 0.2s;
  }

  &__empty__shadow {
    right: 0;
  }

  &__empty__records {
    border: 1px solid $color-border-alt;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: $z-index-loader;
    background: white;
    color: $label;
    font-size: 15px;
  }

  &__shadow_active {
    opacity: 0.15;
    visibility: visible;
  }

  &_scroll {
    .c-table__shadow {
      visibility: visible;
      opacity: 0.15;
    }

    .c-table__column_actions {
      &:after {
        visibility: visible !important;
        opacity: 0.15 !important;
      }
    }

    &.c-table_scroll_end {
      .c-table__shadow {
        visibility: hidden;
        opacity: 0;
      }

      .c-table__column_actions {
        &:after {
          visibility: hidden !important;
          opacity: 0 !important;
        }
      }
    }
  }

  &_scrolled {
    border-left: 1px solid $color-border-light;

    @media screen and (max-width: 992px) {
      border-left: none;

      &:before {
        position: absolute;
        content: "";
        width: 22px;
        height: 100%;
        background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
        top: 0;
        left: 0;
        z-index: 100;
      }
    }
  }

  .c-table {
    &__container {
      border-collapse: collapse;
      width: calc(100% - 1px);
    }

    &__header {
      border-bottom: 2px solid $color-border-light;
      position: relative;
      background: $color-border-light;
      z-index: 70;
    }

    &__header-shadow:after {
      content: "";
      position: absolute;
      background: linear-gradient(#001550, rgba(255, 255, 255, 0));
      width: 100%;
      height: 10px;
      opacity: 0.15;
      z-index: 69;
      bottom: -10px;
      left: 0;
    }

    &__column {
      text-align: left;
      border: 1px solid $color-border-light;
      vertical-align: top;
      height: 1px;
      padding: 0;
      transition: 0.2s;

      &_hidden {
        width: 0;
        border: none;
        overflow: hidden;
        display: none;
        // margin-left: -1px;

        .c-table__column-wrapper {
          width: 0;
          padding: 0;
          border: none;
        }
      }

      &_with {
        &_filter {
          .c-table__column {
            &-wrapper {
              flex-direction: column;
            }

            &-actions {
              margin-top: 10px;
            }
          }
        }
      }

      &_sorted {
        .c-table__column-label {
          color: $color-primary;
        }
      }

      &-label {
        color: $color-label;
        font: {
          size: 12px;
          weight: 500;
        }
        line-height: 13px;

        &-children {
          cursor: pointer;
        }
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        height: 100%;
        background: white;
      }

      &-actions {
        display: flex;
        justify-content: space-between;
      }

      &-action {
        width: 14px;
        height: 14px;

        .c-button {
          width: 14px;
          height: 14px;
        }

        &_description {
          margin-left: -3px;
        }
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 30;

        &:after {
          content: "";
          position: absolute;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
          width: 10px;
          height: 100%;
          left: -11px;
          opacity: 0;
          bottom: 0;
          visibility: hidden;
          z-index: 40;
        }
      }

      &-empty {
        background: white;
        width: calc(100% + 1px);
        height: calc(100% + 2px);
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        border-bottom: 2px solid $color-border-light;
        margin-left: -1px;
        position: relative;
      }
    }

    &__cell {
      border: 1px solid $color-border-light;
      padding: 0;
      height: 1px;
      transition: 0.2s;

      &_number {
        & .c-table__cell-value {
          text-align: right;
          height: 100%;
          white-space: nowrap;
        }
      }

      &_rank {
        & .c-table__cell-value {
          text-align: left;
        }
      }

      &_date,
      &_balance,
      &_actions,
      &_sum_salary,
      &_sum_dynamic,
      &_sum_bonus,
      &_sum_penalty,
      &_amount,
      &_balance_end {
        &::v-deep .collapse.show {
          border-bottom: 1px solid #dfe4ef !important;
          height: 100%;
        }

        & .c-table__cell-value {
          white-space: nowrap !important;
          display: flex !important;
          align-items: center !important;
          justify-content: flex-end !important;
          text-align: right !important;
        }

        & .c-table__cell__grey {
          height: 100% !important;
          white-space: nowrap !important;
          display: flex !important;
          align-items: center !important;
          justify-content: flex-end !important;
          text-align: right !important;
        }
      }

      &_sum_bonus {
        height: 100%;
      }

      &_sum_penalty {
        height: 100%;
      }

      &_date {
        text-align: right;
      }

      &__red {
        background: rgb(255, 211, 232);
      }

      &__green {
        background: rgb(208, 244, 227);
      }

      &__grey {
        background: #f5f7fa !important;
      }

      &__text {
        &__red {
          color: #ff238d;
        }

        &__green {
          color: #12c971;
        }
      }

      &_hidden {
        width: 0;
        overflow: hidden;
        border: none;
        display: none;

        .c-table__cell-value,
        .c-table__cell-cell {
          width: 0;
          padding: 0;
        }
      }

      &-cell {
        transition: 0.2s;
      }

      &-value {
        line-height: 13px;
        font-size: 13px;
        padding: 10px;
        transition: 0.2s;

        &-dropdown {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          &-value {
            margin-left: 9px;
            line-height: 13px;
            font-size: 13px;
          }

          &-button {
            cursor: pointer;
            outline: none;
            margin-right: auto;

            &.not-collapsed {
              transform: rotate(-180deg);
              transition: 0.3s transform ease-in-out;
            }
          }
        }
      }

      &-pre-formatted {
        white-space: pre;
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 20;
      }

      &-actions {
        background: white;
        width: calc(100% + 1px);
        height: 100%;
        display: flex;
        align-items: center;
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        margin-left: -1px;
      }
    }
  }
}

::v-deep .ps__rail-x {
  z-index: 351;
  background: #ffffff !important;
}

::v-deep .ps__rail-x:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-30px, 0);
  box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
  z-index: -1;
  height: 24px;
  width: calc(100vw - 60px);
  background: #ffffff;
}

::v-deep .ps__rail-x:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, calc(-50% + 1px));
  border-radius: 10px;
  z-index: -1;
  height: 4px;
  width: calc(100% - 34px);
  background: #dfe4ef;
}
</style>
